import { Outlet } from "react-router";
import { PlanRouteGuard } from "@/features/auth/components/PlanRouteGuard";
import { PredictionsLayout } from "@/features/predictions/components/PredictionsLayout";

export const PredictionsLayoutOutlet = () => (
  <PlanRouteGuard requiredFeature="service_pronostic">
    <PredictionsLayout>
      <Outlet />
    </PredictionsLayout>
  </PlanRouteGuard>
);

PredictionsLayoutOutlet.displayName = "PredictionsLayoutOutlet";
